import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { HeadingContentContainer } from '../components/heading/heading.js';
import { HeadingActionsContainer } from '../components/heading-actions/heading-actions.js';
import { SectionAPI } from './section-api.js';
import { SectionProperties } from './section-types.js';
import { Section } from './section.js';
const awesomeProps = {
    api: SectionAPI,
    containers: [HeadingActionsContainer, HeadingContentContainer],
    name: 'Section',
    properties: SectionProperties,
    type: ComponentType.NAVIGATION,
};
AwesomeComponent(awesomeProps)(Section);
export * from '../components/heading-section/heading-section-constants.js';
export * from './section-types.js';
export { Section, SectionAPI, };
//# sourceMappingURL=index.js.map